module.exports = __webpack_public_path__ + "static/media/icon_baby.edfcce15.svg";